export const CLIENT_FORGOT_USERID = "CLIENT_FORGOT_USERID";
export const CLIENT_FORGOT_USERID_ERROR = "CLIENT_FORGOT_USERID_ERROR";
export const CLIENT_FORGOT_USERID_HIDE_ERROR = "CLIENT_FORGOT_USERID_HIDE_ERROR";
export const CLIENT_FORGOT_USERID_START_LOADER = "CLIENT_FORGOT_USERID_START_LOADER";
export const CLIENT_FORGOT_USERID_STOP_LOADER = "CLIENT_FORGOT_USERID_STOP_LOADER";
